import React from 'react';
import PropTypes from 'prop-types';

import LabelContent from './label_content';

const LabelTree = (props) => {
  const {
    activeLabelKey,
    expandedLabels,
    labelsTree,
    onLabelSelect,
    toggleExpand
  } = props;

  const labelItem = Object.keys(labelsTree).reduce((acc, labelId) => {
    if (labelId === 'attributes') { return acc; }

    const activeClass = activeLabelKey === labelId ? 'active' : '';
    const expandedClass = expandedLabels[labelId] ? 'expanded' : '';
    const labelChildren = labelsTree[labelId];
    const childCount = Object.keys(labelChildren).length - 1; // subtract out attributes
    const { name, path } = labelChildren.attributes;
    const indentCounter = path.length - 1;

    acc.push(
      <li
        key={labelId}
        className={`label-item ${activeClass} ${expandedClass}`}
      >
        <LabelContent
          onLabelSelect={onLabelSelect}
          toggleExpand={toggleExpand}
          hasChildren={childCount > 0}
          labelId={labelId}
          indentationLevel={indentCounter}
          name={name}
        />
        <LabelTree
          activeLabelKey={activeLabelKey}
          expandedLabels={expandedLabels}
          labelsTree={labelChildren}
          onLabelSelect={onLabelSelect}
          toggleExpand={toggleExpand}
        />
      </li>
    );

    return acc;
  }, []);

  if (labelItem) {
    return <ul className="labels-container">{labelItem}</ul>;
  }

  return labelItem;
};

LabelTree.propTypes = {
  activeLabelKey: PropTypes.string,
  expandedLabels: PropTypes.shape({}).isRequired,
  labelsTree: PropTypes.shape({}).isRequired,
  onLabelSelect: PropTypes.func.isRequired,
  toggleExpand: PropTypes.func.isRequired,
};

LabelTree.defaultProps = {
  activeLabelKey: null,
};

export default LabelTree;
